import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { COMPACT_FILTERS } from '@/lib/tableDensity';

export const CompactPeriodFilters = ({
  period,
  startDate,
  endDate,
  onPeriodChange,
  onStartDateChange,
  onEndDateChange,
  periodTestId,
  startDateTestId,
  endDateTestId,
}) => (
  <div className={COMPACT_FILTERS.container}>
    <div className="min-w-[180px]">
      <Label className={COMPACT_FILTERS.label}>Período</Label>
      <Select value={period} onValueChange={onPeriodChange}>
        <SelectTrigger className={COMPACT_FILTERS.control} data-testid={periodTestId}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="today">Hoje</SelectItem>
          <SelectItem value="this_week">Esta semana</SelectItem>
          <SelectItem value="this_month">Este mês</SelectItem>
          <SelectItem value="all">Todo período</SelectItem>
          <SelectItem value="custom">Personalizado</SelectItem>
        </SelectContent>
      </Select>
    </div>
    {period === 'custom' && (
      <>
        <div className="min-w-[170px]">
          <Label className={COMPACT_FILTERS.label}>De</Label>
          <Input type="date" value={startDate} onChange={(e) => onStartDateChange(e.target.value)} className={COMPACT_FILTERS.control} data-testid={startDateTestId} />
        </div>
        <div className="min-w-[170px]">
          <Label className={COMPACT_FILTERS.label}>Até</Label>
          <Input type="date" value={endDate} onChange={(e) => onEndDateChange(e.target.value)} className={COMPACT_FILTERS.control} data-testid={endDateTestId} />
        </div>
      </>
    )}
  </div>
);